







































import Vue from 'vue';
import { mapState } from 'vuex';
import HubIcon from '@/components/HubComponents/HubIcon.vue';

export default Vue.extend({
  name: 'HubDatePicker' as string,
  components: {
    HubIcon,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      date: this.value,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    formatDate(date: string): string {
      return date.split('-').reverse().join(' / ');
    },
  },
});
